module.exports = __webpack_public_path__ + "img/jd.04fca8b3.png";